import { dew as _concatDew } from "../data/concat.js";
import { dew as _isBytesDew } from "../data/isBytes.js";
import { dew as _padDew } from "../data/pad.js";
import { dew as _sliceDew } from "../data/slice.js";
import { dew as _toBytesDew } from "../encoding/toBytes.js";
import { dew as _toRlpDew } from "../encoding/toRlp.js";
import { dew as _keccakDew } from "../hash/keccak256.js";
import { dew as _getAddressDew } from "./getAddress.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getCreate2Address = exports.getCreateAddress = exports.getContractAddress = void 0;
  const concat_js_1 = _concatDew();
  const isBytes_js_1 = _isBytesDew();
  const pad_js_1 = _padDew();
  const slice_js_1 = _sliceDew();
  const toBytes_js_1 = _toBytesDew();
  const toRlp_js_1 = _toRlpDew();
  const keccak256_js_1 = _keccakDew();
  const getAddress_js_1 = _getAddressDew();
  function getContractAddress(opts) {
    if (opts.opcode === "CREATE2") return getCreate2Address(opts);
    return getCreateAddress(opts);
  }
  exports.getContractAddress = getContractAddress;
  function getCreateAddress(opts) {
    const from = (0, toBytes_js_1.toBytes)((0, getAddress_js_1.getAddress)(opts.from));
    let nonce = (0, toBytes_js_1.toBytes)(opts.nonce);
    if (nonce[0] === 0) nonce = new Uint8Array([]);
    return (0, getAddress_js_1.getAddress)(`0x${(0, keccak256_js_1.keccak256)((0, toRlp_js_1.toRlp)([from, nonce], "bytes")).slice(26)}`);
  }
  exports.getCreateAddress = getCreateAddress;
  function getCreate2Address(opts) {
    const from = (0, toBytes_js_1.toBytes)((0, getAddress_js_1.getAddress)(opts.from));
    const salt = (0, pad_js_1.pad)((0, isBytes_js_1.isBytes)(opts.salt) ? opts.salt : (0, toBytes_js_1.toBytes)(opts.salt), {
      size: 32
    });
    const bytecodeHash = (() => {
      if ("bytecodeHash" in opts) {
        if ((0, isBytes_js_1.isBytes)(opts.bytecodeHash)) return opts.bytecodeHash;
        return (0, toBytes_js_1.toBytes)(opts.bytecodeHash);
      }
      return (0, keccak256_js_1.keccak256)(opts.bytecode, "bytes");
    })();
    return (0, getAddress_js_1.getAddress)((0, slice_js_1.slice)((0, keccak256_js_1.keccak256)((0, concat_js_1.concat)([(0, toBytes_js_1.toBytes)("0xff"), from, salt, bytecodeHash])), 12));
  }
  exports.getCreate2Address = getCreate2Address;
  //# sourceMappingURL=getContractAddress.js.map
  return exports;
}